import { Body } from 'copilot-design-system';
import React from 'react';
import { DateSeparatorProps } from 'stream-chat-react';

import { RowDivider } from 'src/components/RowDivider';
import DateUtils from 'src/utils/DateUtils';

export const CustomDateSeparator: React.FC<DateSeparatorProps> = React.memo(
  ({ date, unread }) => {
    const when = React.useMemo(
      () =>
        DateUtils.humanizeDate(date.toISOString(), {
          lastWeek: 'ddd h:mm A',
          sameElse: 'MMM DD, YYYY, h:mm A',
        }),
      [date],
    );
    return (
      <RowDivider className="my-3" colorClassName="bg-secondary-hover">
        <Body className="whitespace-nowrap text-center text-[15px] text-gray-small">
          {unread ? `New - ${when}` : when}
        </Body>
      </RowDivider>
    );
  },
);
